import React, { useEffect, useRef, useState } from "react";
import "./UFOFlyCoordinates.css";
import Notification from "../Notifications/Notification.js";
import { Modal } from "antd";
import { useNavigate } from "react-router-dom";
import userService from "../../../services/userService.js";
import UFOMotion from "../UFOFlyEffect/UFOMotion.js";
import { FaceMesh } from "@mediapipe/face_mesh";

const UFOCoordinates = () => {

  const navigate = useNavigate();
  const [coordinateNumber, setCoordinateNumber] = useState(0);
  const [haveIt, setHaveIt] = useState([]);
  const [moveNext, setMoveNext] = useState(false);
  const [startAnimation, setStartAnimation] = useState(true);
  const [xStart, setXStart] = useState(800);
  const [yStart, setYStart] = useState(350);
  const [xTarget, setXTarget] = useState();
  const [yTarget, setYTarget] = useState();
  const [dataPointX, setDataPointX] = useState();
  const [dataPointY, setDataPointY] = useState();
  const [modalState, setModalState] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [typeId, setTypeId] = useState();
  const [calibrationData, setCalibrationData] = useState([]);
  const [clickCount, setClickCount] = useState(null);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const videoRef = useRef(null);
  const canvasRef = useRef(null);
  // const [capturedImage, setCapturedImage] = useState(null);
  // const [isProcessing, setIsProcessing] = useState(false);
  const [faceMesh, setFaceMesh] = useState(null);
  const [currFaceMesh, setCurrFaceMesh] = useState(null)
  let x, y;

  useEffect(() => {
    try {
      window.addEventListener('online', () => { setModalState(false); setShowModal(false); });
      window.addEventListener('offline', () => { setTypeId(1); setModalState(true); setShowModal(true); });

    } catch (error) {
      console.log(`Unable to fetch Internet status`);
    }
    checkCalibrationStatus();
  }, [])
  
  useEffect(() => {
    const handleBeforeUnload = (event) => {
      event.preventDefault();
      startNewGame();
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);

  useEffect(() => {
    generateUniqueRandom();
    try {
      let Id = localStorage.getItem("calibrationId")
      if(!Id){
          setShowErrorModal(true)
          // alert("Oops! An error occured.")
      }
    } catch (error) {
      
    }

    // handleTrapped();
  }, [moveNext]); 
  
  useEffect(() => {

    const facemesh= new FaceMesh({
      locateFile: (file) => `https://cdn.jsdelivr.net/npm/@mediapipe/face_mesh/${file}`,
    });

  facemesh.setOptions({
      maxNumFaces: 1,
      refineLandmarks:true,
      minDetectionConfidence: 0.5,
      minTrackingConfidence: 0.5,
  });

  facemesh.onResults((results) => {
      let demoArr = results.multiFaceLandmarks[0]?.flatMap(obj => [parseInt(obj.x*10000), parseInt(obj.y*10000), parseInt(obj.z*10000)]);
      setCurrFaceMesh([demoArr])
  });
  setFaceMesh(facemesh)
  },[])


  useEffect(() => {
    if(!!currFaceMesh){
      currFaceMesh[0].unshift(dataPointY)
      currFaceMesh[0].unshift(dataPointX)
      currFaceMesh[0].unshift(clickCount)  
    }
    
    if (!!clickCount) {
      console.log(`calibration Data:${calibrationData.length}`);
      setCalibrationData((prev) => [...prev, currFaceMesh[0]]);
    }

  },[currFaceMesh])

  useEffect(() => {
    const initializeCamera = async () => {

      try {
        const stream = await navigator.mediaDevices.getUserMedia({ video: true });
        if (videoRef.current) {
          videoRef.current.srcObject = stream;
        }
      } catch (err) {
        console.error("Error accessing webcam: ", err);
      }
    };

    initializeCamera();

    return () => {
      if (videoRef.current && videoRef.current.srcObject) {
        const stream = videoRef.current.srcObject;
        const tracks = stream.getTracks();
        tracks.forEach((track) => track.stop());
      }
    };
  }, []);

  const switchCameraOff = () => {
    if (videoRef.current && videoRef.current.srcObject) {
      const stream = videoRef.current.srcObject;
      const tracks = stream.getTracks();
      tracks.forEach((track) => track.stop());
    }
  }

  const startNewGame = async() => {
      let response
      try {
        response = await userService.startCalibrationProcess();

        if (response.error) {
          console.log(`Start Calibration Error:${response.error}`);
        } else {
          localStorage.setItem("calibrationId", response?.data?.calibrationId);
          navigate("/calibration/game");
        }
      } catch (error) {
        alert("Found some issues!")
        switchCameraOff()
        navigate("/calibration/start")
      }
  }

  const checkCalibrationStatus = async () => {
    try {
      const response = await userService.checkUserCalibrationStatus();

      if (response.error) {
        console.log(`Calibration Status Error:${response.error}`);
      } else {
        console.log(`Calibration Status${JSON.stringify(response)}`);
      }
    } catch (error) {
      console.log(error);
    }
  }

  const handleModalEvent = () => {
    setModalState(!modalState)
  }

  const handleErrorModalEvent = () => {
      switchCameraOff()
      navigate("/calibration/start");
  }

  const sendDatatoServer = async (calibrationData) => {
    let Id;
    try {
      Id = localStorage.getItem("calibrationId")
    } catch (error) {
      console.log(`Unable to find calibrationId in localstorage`);
    }
    if(!Id){
      alert("Oops! An Error occured.")
      switchCameraOff()
      navigate("/calibration/start")
    }else{
      try {
        let data = {
          "data": calibrationData
        };
        const response = await userService.sendCalibrationData(Id, data);
        if (response.error) {
          console.log(`Error in response:${response.error}`);
          navigate("/calibration/error");
        } else {
          setCalibrationData([]);
          if (response?.data?.calibrationStatus == "COMPLETED") {
            switchCameraOff()
            navigate("/calibration/success");
            try {
              localStorage.removeItem("calibrationId");
            } catch (error) {}
          }
        }
      } catch (error) {
        console.log(error);
      }
    }
  }

  const generateUniqueRandom = () => {
    //Generating random number within 1-13
    let random = Math.floor(Math.random() * (13 - 1 + 1) + 1);
    random = Number(random);

    if (!haveIt.includes(random)) {
      setCoordinateNumber(random);
      setHaveIt([...haveIt, random]);
      return random;
    } else {
      if (haveIt.length < 13) {
        //Recursively generate number
        return generateUniqueRandom(13);
      } else {
        setHaveIt([]);
        // window.location.reload();
        return false;
      }
    }
  };

  // Facemesh predictions
  
  const captureImage = () => {

    // setIsProcessing(true); // Set processing state to true
    const canvas = canvasRef.current;
    const video = videoRef.current;

    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;
    const ctx = canvas.getContext('2d');
    ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

    const dataURL = canvas.toDataURL('image/jpeg');
    // setCapturedImage(dataURL);

    // Create an image element for processing
    const img = new Image();
    img.src = dataURL;
    img.onload = async () => {
      await detectLandmarksInImage(img); // Call landmark detection
    };
    
  };

  const detectLandmarksInImage = async (image) => {
    if(faceMesh !== null) {
      await faceMesh.send({ image });
    }
  };


  // getting the x y cordinate from the ref elements and converting cordinates px to percentage
  const cordinateRef = useRef(null);
  const invalidRef = useRef(null);

  useEffect(() => {
    if (cordinateRef) {
      const xValue = cordinateRef?.current?.offsetLeft;
      const yValue = cordinateRef?.current?.offsetTop;
      x = Math.floor((xValue / window.innerWidth) * 100);
      y = Math.floor((yValue / window.innerHeight) * 100);
      setXTarget(xValue);
      setYTarget(yValue);
      setDataPointX(x);
      setDataPointY(y);
      console.log({ x, y });
    }
  }, [coordinateNumber]);

  useEffect(() => {

    if(clickCount == 1 || clickCount == 2 || clickCount == 3) captureImage();

    if(calibrationData.length % 3 == 0 &&  calibrationData.length != 0){
        sendDatatoServer(calibrationData);
        setCurrFaceMesh(null)
    }

    else if (clickCount == 2) {
      setXStart(xTarget)
      setYStart(yTarget)
    }
    else if (clickCount == 3) {
      setTimeout(() => {
        setMoveNext((moveNext) => !moveNext);
        setStartAnimation(true);
        setClickCount(null);
      }, 500);
    }

  }, [clickCount]);


  return (
    <section>

      <video 
        ref={videoRef} 
        autoPlay 
        playsInline 
        style={{width: '640', display:"none"}} 
      />
      <canvas ref={canvasRef} style={{ display: "none" }}></canvas>
      {showErrorModal && <Modal
              className="warning-modal"
              centered
              open={showErrorModal}
              onOk={handleErrorModalEvent}
              closable={false}
            >
              <h4>Oops! We encountered an Error.</h4>
      </Modal>}

      {showModal && <Modal
        className="warning-modal"
        centered
        footer={false}
        open={modalState}
        onOk={handleModalEvent}
        onCancel={handleModalEvent}
      >
        <Notification
          typeId={typeId}
        />
      </Modal>}

      <UFOMotion
        start={{ x: xStart, y: yStart }}
        end={{ x: xTarget, y: yTarget }}
        shouldStart={startAnimation}
        setStartAnimation={setStartAnimation}
        onStop={null}
        setClickCount={setClickCount}
        turns={5}
      />

      <div className="cordinates-screen-bg">
        <div className="d-flex justify-content-between">
          <div
            className={`${coordinateNumber === 1 && "cordinate-ball"}
            ${coordinateNumber === 1 && clickCount === 0 && "trapped"} ${coordinateNumber === 1 && clickCount === 1 && "first-click"
              }
            ${coordinateNumber === 1 && clickCount === 2 && "second-click"}
            ${coordinateNumber === 1 && clickCount === 3 && "third-click"}`}
            ref={coordinateNumber === 1 ? cordinateRef : invalidRef}
            onClick={() => {
              cordinateRef.current.style.pointerEvents = 'none';
              setClickCount(clickCount + 1);
              setTimeout(() => {
                cordinateRef.current.style.pointerEvents = 'auto'
              },1000)
            }}
          ></div>
          <div
            className={`${coordinateNumber === 2 && "cordinate-ball"}
                ${coordinateNumber === 2 && clickCount === 0 && "trapped"} ${coordinateNumber === 2 && clickCount === 1 && "first-click"
              }
                ${coordinateNumber === 2 && clickCount === 2 && "second-click"}
                ${coordinateNumber === 2 && clickCount === 3 && "third-click"}`}
            ref={coordinateNumber === 2 ? cordinateRef : invalidRef}
            onClick={() => {
              cordinateRef.current.style.pointerEvents = 'none';
              setClickCount(clickCount + 1);
              setTimeout(() => {
                cordinateRef.current.style.pointerEvents = 'auto'
              },1000)
            }}
            ></div>
          <div
            className={`${coordinateNumber === 3 && "cordinate-ball"}
               ${coordinateNumber === 3 && clickCount === 0 && "trapped"} ${coordinateNumber === 3 && clickCount === 1 && "first-click"
              }
               ${coordinateNumber === 3 && clickCount === 2 && "second-click"}
               ${coordinateNumber === 3 && clickCount === 3 && "third-click"}`}
            ref={coordinateNumber === 3 ? cordinateRef : invalidRef}
               onClick={() => {
              cordinateRef.current.style.pointerEvents = 'none';
              setClickCount(clickCount + 1);
              setTimeout(() => {
                cordinateRef.current.style.pointerEvents = 'auto'
              },1000)
            }}
          ></div>
        </div>

        <div className="d-flex justify-content-around">
          <div
            className={`${coordinateNumber === 4 && "cordinate-ball"}
              ${coordinateNumber === 4 && clickCount === 0 && "trapped"} ${coordinateNumber === 4 && clickCount === 1 && "first-click"
              }
              ${coordinateNumber === 4 && clickCount === 2 && "second-click"}
              ${coordinateNumber === 4 && clickCount === 3 && "third-click"}`}
            ref={coordinateNumber === 4 ? cordinateRef : invalidRef}
               onClick={() => {
              cordinateRef.current.style.pointerEvents = 'none';
              setClickCount(clickCount + 1);
              setTimeout(() => {
                cordinateRef.current.style.pointerEvents = 'auto'
              },1000)
            }}
          ></div>
          <div
            className={`${coordinateNumber === 5 && "cordinate-ball"}
               ${coordinateNumber === 5 && clickCount === 0 && "trapped"} ${coordinateNumber === 5 && clickCount === 1 && "first-click"
              }
               ${coordinateNumber === 5 && clickCount === 2 && "second-click"}
               ${coordinateNumber === 5 && clickCount === 3 && "third-click"}`}
            ref={coordinateNumber === 5 ? cordinateRef : invalidRef}
               onClick={() => {
              cordinateRef.current.style.pointerEvents = 'none';
              setClickCount(clickCount + 1);
              setTimeout(() => {
                cordinateRef.current.style.pointerEvents = 'auto'
              },1000)
            }}
          ></div>
        </div>

        <div className="d-flex justify-content-between">
          <div
            className={`${coordinateNumber === 6 && "cordinate-ball"}
             ${coordinateNumber === 6 && clickCount === 0 && "trapped"} ${coordinateNumber === 6 && clickCount === 1 && "first-click"
              }
             ${coordinateNumber === 6 && clickCount === 2 && "second-click"}
             ${coordinateNumber === 6 && clickCount === 3 && "third-click"}`}
            ref={coordinateNumber === 6 ? cordinateRef : invalidRef}
               onClick={() => {
              cordinateRef.current.style.pointerEvents = 'none';
              setClickCount(clickCount + 1);
              setTimeout(() => {
                cordinateRef.current.style.pointerEvents = 'auto'
              },1000)
            }}
          ></div>
          <div
            className={`${coordinateNumber === 7 && "cordinate-ball"}
              ${coordinateNumber === 7 && clickCount === 0 && "trapped"} ${coordinateNumber === 7 && clickCount === 1 && "first-click"
              }
              ${coordinateNumber === 7 && clickCount === 2 && "second-click"}
              ${coordinateNumber === 7 && clickCount === 3 && "third-click"}`}
            ref={coordinateNumber === 7 ? cordinateRef : invalidRef}
               onClick={() => {
              cordinateRef.current.style.pointerEvents = 'none';
              setClickCount(clickCount + 1);
              setTimeout(() => {
                cordinateRef.current.style.pointerEvents = 'auto'
              },1000)
            }}
          ></div>
          <div
            className={`${coordinateNumber === 8 && "cordinate-ball"}
               ${coordinateNumber === 8 && clickCount === 0 && "trapped"} ${coordinateNumber === 8 && clickCount === 1 && "first-click"
              }
               ${coordinateNumber === 8 && clickCount === 2 && "second-click"}
               ${coordinateNumber === 8 && clickCount === 3 && "third-click"}`}
            ref={coordinateNumber === 8 ? cordinateRef : invalidRef}
               onClick={() => {
              cordinateRef.current.style.pointerEvents = 'none';
              setClickCount(clickCount + 1);
              setTimeout(() => {
                cordinateRef.current.style.pointerEvents = 'auto'
              },1000)
            }}
          ></div>
        </div>

        <div className="d-flex justify-content-around">
          <div
            className={`${coordinateNumber === 9 && "cordinate-ball"}
             ${coordinateNumber === 9 && clickCount === 0 && "trapped"} ${coordinateNumber === 9 && clickCount === 1 && "first-click"
              }
             ${coordinateNumber === 9 && clickCount === 2 && "second-click"}
             ${coordinateNumber === 9 && clickCount === 3 && "third-click"}`}
            ref={coordinateNumber === 9 ? cordinateRef : invalidRef}
               onClick={() => {
              cordinateRef.current.style.pointerEvents = 'none';
              setClickCount(clickCount + 1);
              setTimeout(() => {
                cordinateRef.current.style.pointerEvents = 'auto'
              },1000)
            }}
          ></div>
          <div
            className={`${coordinateNumber === 10 && "cordinate-ball"}
               ${coordinateNumber === 10 && clickCount === 0 && "trapped"} ${coordinateNumber === 10 && clickCount === 1 && "first-click"
              }
               ${coordinateNumber === 10 && clickCount === 2 && "second-click"}
               ${coordinateNumber === 10 && clickCount === 3 && "third-click"}`}
            ref={coordinateNumber === 10 ? cordinateRef : invalidRef}
               onClick={() => {
              cordinateRef.current.style.pointerEvents = 'none';
              setClickCount(clickCount + 1);
              setTimeout(() => {
                cordinateRef.current.style.pointerEvents = 'auto'
              },1000)
            }}
          ></div>
        </div>

        <div className="d-flex justify-content-between">
          <div
            className={`${coordinateNumber === 11 && "cordinate-ball"}
                ${coordinateNumber === 11 && clickCount === 0 && "trapped"} ${coordinateNumber === 11 && clickCount === 1 && "first-click"
              }
                ${coordinateNumber === 11 && clickCount === 2 && "second-click"}
                ${coordinateNumber === 11 && clickCount === 3 && "third-click"}`}
            ref={coordinateNumber === 11 ? cordinateRef : invalidRef}
               onClick={() => {
              cordinateRef.current.style.pointerEvents = 'none';
              setClickCount(clickCount + 1);
              setTimeout(() => {
                cordinateRef.current.style.pointerEvents = 'auto'
              },1000)
            }}
          ></div>
          <div
            className={`${coordinateNumber === 12 && "cordinate-ball"}
               ${coordinateNumber === 12 && clickCount === 0 && "trapped"} ${coordinateNumber === 12 && clickCount === 1 && "first-click"
              }
               ${coordinateNumber === 12 && clickCount === 2 && "second-click"}
               ${coordinateNumber === 12 && clickCount === 3 && "third-click"}`}
            ref={coordinateNumber === 12 ? cordinateRef : invalidRef}
               onClick={() => {
              cordinateRef.current.style.pointerEvents = 'none';
              setClickCount(clickCount + 1);
              setTimeout(() => {
                cordinateRef.current.style.pointerEvents = 'auto'
              },1000)
            }}
          ></div>
          <div
            className={`${coordinateNumber === 13 && "cordinate-ball"}
         ${coordinateNumber === 13 && clickCount === 0 && "trapped"} ${coordinateNumber === 13 && clickCount === 1 && "first-click"
              }
         ${coordinateNumber === 13 && clickCount === 2 && "second-click"}
         ${coordinateNumber === 13 && clickCount === 3 && "third-click"}`}
            ref={coordinateNumber === 13 ? cordinateRef : invalidRef}
               onClick={() => {
              cordinateRef.current.style.pointerEvents = 'none';
              setClickCount(clickCount + 1);
              setTimeout(() => {
                cordinateRef.current.style.pointerEvents = 'auto'
              },1000)
            }}
          ></div>
        </div>
      </div>
    </section>
  );
};

export default UFOCoordinates;